@let uiStyle = $_uiStyle();
@if (uiStyle != "hidden" && $interfaceDescriptors().length > 0) {
    <div class="cm-configurator-menu">
        <div class="cm-menu-content">
            @if ($minimized()) {
                <div (click)="$minimized.set(!$minimized())" class="cm-minimized-menu">
                    <i class="far fa-sliders-h"></i>
                </div>
            } @else {
                @if (uiStyle === "default") {
                    <cm-default-menu [interfaceDescriptors]="$interfaceDescriptors()"></cm-default-menu>
                }
                @if (uiStyle === "accordion" || uiStyle === "icons") {
                    <cm-icons-accordion-menu
                        [useCaptions]="$useCaptions()"
                        [interfaceDescriptors]="$interfaceDescriptors()"
                        [uiStyle]="uiStyle"
                        [tooltipContainer]="tooltipContainer"
                        [accordionStyle]="$accordionStyle()"
                        [(selectedDescriptorIds)]="$selectedDescriptorIds"
                    ></cm-icons-accordion-menu>
                }
                @if (uiStyle === "mobileTabs") {
                    <cm-mobile-tabs-menu
                        [useCaptions]="$useCaptions()"
                        [interfaceDescriptors]="$interfaceDescriptors()"
                        [tooltipContainer]="tooltipContainer"
                        [(selectedDescriptorIds)]="$selectedDescriptorIds"
                    ></cm-mobile-tabs-menu>
                }
            }
        </div>
        <div class="cm-minimize-menu-container">
            @if (!$minimized() && !$externalMenu()) {
                <div (click)="$minimized.set(!$minimized())" class="cm-minimize-menu">
                    <i class="far fa-chevron-down"></i>
                </div>
            }
        </div>

        <div class="tooltip-container" #tooltipContainer></div>
    </div>
}
